import React from "react";
import Marquee from "react-fast-marquee";
import '../../sass/components/flexibleModules/_components.genericMarqueeSection.scss';

const GenericMarqueeSection = ({ data }) => {
    return (
        <div className="cp-genericMarqueeSection" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericMarqueeSection__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <Marquee direction="right" speed="100" gradient="false" gradientColor="none">
                    {data.genericMarqueeSectionContentOne &&
                        <p>{data.genericMarqueeSectionContentOne}</p>
                    }
                    {data.genericMarqueeSectionContentTwo &&
                        <p>{data.genericMarqueeSectionContentTwo}</p>
                    }
                </Marquee>
            </div>
        </div>
    );
}

export default GenericMarqueeSection;